import { render } from "./ManualInputPage.vue?vue&type=template&id=67d42030"
import script from "./ManualInputPage.vue?vue&type=script&lang=js"
export * from "./ManualInputPage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ASMPP\\ASMPP_VUE\\asmpp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__